$(document).ready(function () {
$(".dropdown-toggle-two").click(function(){
  $(".dropdown-menu-two").toggleClass("langopen");
});

$(".dropdown-toggle-one").click(function(){
  $(".dropdown-menu-one").toggleClass("langopen");
});
  
});  


document.addEventListener("DOMContentLoaded", function() {
    // Get the current page URL
    let currentUrl = window.location.href;

    // Construct the LinkedIn share URL with the correct subdomain
    let linkedInShareUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(currentUrl)}`;

    // Select the LinkedIn share button by class
    let linkedInButton = document.querySelector(".share-buttons--linkedin");
    if (linkedInButton) {
      //alert(linkedInShareUrl);
        linkedInButton.href = linkedInShareUrl;
    }
});


